import { Component, OnInit, OnChanges, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { DispatchBoardPanels } from "../../../shared/enums/DispatchBoardPanels";
import { DispatchBoardService } from '../../../shared/services/dispatch-board.service';
import { DispatchBoardSearch } from '../../../shared/models/DispatchBoardSearch';
import { v_DispatchGrid2Bus } from '../../../shared/models/v_DispatchGrid2Bus';
import { GlobalsService } from '../../../shared/services/globals.service';
import { WindowContents } from '../../../shared/enums/windowContents';

import { Observable, Subscription, of } from 'rxjs';
import { DragParent } from '@app/cp/shared/enums/DragParent';
import { delay, mergeMap, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'cp-status-calendar-panel-detail',
    templateUrl: './status-panel-detail-calendar.component.html',
    styleUrls: ['./status-panel-detail-calendar.component.scss']
})
export class StatusPanelDetailCalendarComponent implements OnInit {

    subscriptions: Subscription[] = [];

    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService) {
        this.subscriptions.push(svc_data.hoverStatusPanel$.subscribe(
            hover => {
                this.hidePanel = hover;
                this.mouseLeft = hover;
            }));
        this.subscriptions.push(svc_data.refreshTrigger$.subscribe(
            refresh => {
                //if ( this.svc_data.getStatusToRefresh() == this.detailData.statusId)
                //{ this.initData();}

            }));
        this.subscriptions.push(svc_data.selectedDispatch$.subscribe(
            dispatch => {
                this.selectedDispatch = dispatch;
            }));
        this.subscriptions.push(svc_data.statusDetailPanelClose$.subscribe(
            close => {
                this.closeWindow();
            }));
    }

    private _mouseEnterStream: EventEmitter<any> = new EventEmitter();
    private _mouseLeaveStream: EventEmitter<any> = new EventEmitter();
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    ngOnInit() {
        this.initData();
    }

    ngOnchanges() {

    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    sch: DispatchBoardSearch = new DispatchBoardSearch(null);
    data: v_DispatchGrid2Bus[];
    searchParam: DispatchBoardSearch;

    public prioritiesFilter: string = '';
    loadingIndicator: boolean = true;

    @Input() detailData: any = { description: 'Title', value: '000' };

    dispatches: any;

    @Output() closed = new EventEmitter<DispatchBoardPanels>();
    @Output() openRequest = new EventEmitter<object>();
    public panelTypes = DispatchBoardPanels;
    public contentTypes = WindowContents;

    hidePanel: boolean = false;
    mouseLeft: boolean = false;

    selectedDispatch: string = '';

    customerFilter: string = '';
    priorityFilter: string = '';

    initData() {

        //this.loadingIndicator = true;
        //this.data = null;
        //this.dispatches = null;
        this.searchParam = this.sch;
        this.searchParam.userId = this.svc_globals.userId;
        this.searchParam.statusId = this.detailData.statusId;
        this.searchParam.excludeContracts = true;
        this.svc_data.getDispatchesByFilter(this.searchParam).subscribe(data => {
            this.data = data;

            this.sortDispatches(this.data);

            this.loadingIndicator = false;

            if (data.error) {
                alert('got an error back!');
            }

        });
    }

    sortDispatches(data: any) {

        if (this.svc_data.dispatchSort) {

            switch (this.svc_data.dispatchSort) {
                case "CreatedPriorityLocation":
                    data.sort(function (a, b) {
                        if (a.receivedDateTime > b.receivedDateTime) { return 1 };
                        if (a.receivedDateTime < b.receivedDateTime) { return -1 };
                        if (a.priorityName > b.priorityName) { return 1 };
                        if (a.priorityName < b.priorityName) { return -1 };
                        if (a.locationName > b.locationName) { return 1 };
                        if (a.locationName < b.locationName) { return -1 };
                    });

                    break;
                case "CustomerLocation":
                    data.sort(function (a, b) {
                        if (a.customerId > b.customerId) { return 1 };
                        if (a.customerId < b.customerId) { return -1 };
                        if (a.locationName > b.locationName) { return 1 };
                        if (a.locationName < b.locationName) { return -1 };
                    });

                    break;

                case "TimeInStatus":
                    data.sort(function (a, b) {
                        if (a.lastStatusChangeDt > b.lastStatusChangeDt) { return 1 };
                        if (a.lastStatusChangeDt < b.lastStatusChangeDt) { return -1 };
                    });

                    break;

                case "Rank":
                    data.sort(function (a, b) {
                        var a1 = a.timeValue;
                        var b1 = b.timeValue;
                        if (!a1) a1 = 99;
                        if (!b1) b1 = 99;
                        if (a1 > b1) { return 1 };
                        if (a1 < b1) { return -1 };
                    });

                    break;

                default:

            }
        }
        this.dispatches = data;
    }

    closeWindow() {
        this.closed.emit(this.panelTypes.status);
    }

    openWindow(dispatch, trigger) {
        let passedData;
        let windowData;
        //alert(JSON.stringify(dispatch));
        switch (trigger) {
            case 1:
                passedData = { data: this.svc_data.statusList, moveDispatch: dispatch };
                windowData = { contentType: this.contentTypes.moveStatus, boardData: passedData };

                this.openRequest.emit(windowData);
                break;
            case 2:
                passedData = { data: this.svc_data.techList, assignDispatch: dispatch };
                windowData = { contentType: this.contentTypes.assignTech, boardData: passedData };

                this.openRequest.emit(windowData);
                break;
            case 3:
                passedData = { data: {}, viewDispatch: dispatch };
                windowData = { contentType: this.contentTypes.viewDispatch, boardData: passedData };

                this.openRequest.emit(windowData);
                break;
        }

    }

    setSelectedDispatch(dispatch: v_DispatchGrid2Bus) {

        this.svc_data.setSelectedDispatch(dispatch.dispatchId);
    }

    doubleClick(e) {
        //alert('open dispatch: ' + e.dispatchId);
    }

    public showFilter: boolean = false;

    filter() {
        this.showFilter = !this.showFilter;
    }

    setPriorityFilter(filter) {
        this.prioritiesFilter = filter;
    }

    dispatchDragging(e) {
        this.svc_data.setDragParent(DragParent.statusPanelDetail);
        this.svc_data.dispatchDragging(e.dispatch, e.dragState, DragParent.statusPanelDetail);
    }

    onMouseEnter(e) {
        this.mouseLeft = false;
        this._mouseEnterStream.emit(e);
    }

    onMouseLeave(e) {
        this.mouseLeft = true;
        this._mouseLeaveStream.emit(e);
    }

    mouseOver(e, hover) {
        if (hover) {
            this._mouseLeaveStream.pipe(mergeMap((ev) => {
                return of(ev)
                    .pipe(delay(850))
                    .pipe(takeUntil(this._mouseEnterStream));
            })).subscribe(
                (ev) => {
                    this.svc_data.hoveringStatusPanel(hover);
                }
            );
        } else {
            this._mouseEnterStream.pipe(mergeMap((ev) => {
                return of(ev)
                    .pipe(delay(850))
                    .pipe(takeUntil(this._mouseLeaveStream));
            })).subscribe(
                (ev) => {
                    this.svc_data.hoveringStatusPanel(hover);
                }
            );
        }
    }

    setCustomerFilter(e) {
        if (e && e.value) {
            this.customerFilter = e.value;
        } else {
            this.customerFilter = '';
        }

    }
    //setPriorityFilter(e) {
    //    this.customerFilter = e;
    //}
}
